import { render, staticRenderFns } from "./ProjectCommentActions.vue?vue&type=template&id=76eb3714&"
import script from "./ProjectCommentActions.vue?vue&type=script&lang=js&"
export * from "./ProjectCommentActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports